        const AEA_PLACE_ORDER = ['home_inferred', 'work_inferred', 'routine', 'sensitive', 'transient'];

export { AEA_PLACE_ORDER };
